const styles = () => ({
  noPadding: {
    padding: 0
  }
});

export default styles;
